module.exports = __webpack_public_path__ + "img/leartime.a7542287.png";